export const ESSENTIALS_TRIPLES_LIMIT = 50000000;
export const FREE_TRIPLES_LIMIT = 1000000;
